/**
 * Extracts the user-friendly error message returned by the LIO Portal API.
 *
 * The API returns errors as JSON of the shape `{ error: { message: string } }`.
 * If the message is present, it is preferred over the UI fallback since the API
 * is the source of truth for user-facing error copy. If the API did not return
 * a message (network failure, non-JSON response, etc.), the provided fallback
 * is used instead.
 */
export const getApiErrorMessage = async (error: unknown, fallback: string): Promise<string> => {
  try {
    const response = (error as { response?: { json?: () => Promise<unknown> } })?.response;
    const data = (await response?.json?.()) as { error?: { message?: string } } | undefined;
    return data?.error?.message ?? fallback;
  } catch {
    return fallback;
  }
};
